import { render, staticRenderFns } from "./LbaFavouritePage.vue?vue&type=template&id=5f2b2934&scoped=true"
import script from "./LbaFavouritePage.vue?vue&type=script&lang=js"
export * from "./LbaFavouritePage.vue?vue&type=script&lang=js"
import style0 from "./LbaFavouritePage.vue?vue&type=style&index=0&id=5f2b2934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2b2934",
  null
  
)

export default component.exports